module.exports = __webpack_public_path__ + "images/tips/getting-started@1x.2941dcb8f80843b28a02.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/getting-started@1x.png
// module id = TvWA
// module chunks = 13